module.exports = __webpack_public_path__ + "img/discountSale.d361cf69.png";